import React from 'react'

const AlertMsg = ({heading,text, alertBoxColor}) => {
  return (
    <>
    <div className={`alertBox ${alertBoxColor}`}>
        <p className='alertBoxTitle'>{heading}</p>
        <p className='alertBoxtext'>{text}</p>

     </div>
    </>
  )
}

export default AlertMsg